import React from "react";
import { JSInputComponent, JSInputProps } from "../JamezzStylesCSSInput";
import FormSelect from "../../../../../../components/Forms/FormSelect";
import { MenuItem } from "@mui/material";

function TextDecoration({ name, required }: JSInputProps) {
  return (
    <FormSelect
      name={name}
      options={[
        <MenuItem key={"none"} value={""}>
          None
        </MenuItem>,
        <MenuItem key={"underline"} style={{ textDecoration: "underline" }} value={"underline"}>
          Underline
        </MenuItem>,
      ]}
      rules={{ required }}
    />
  );
}

export const JSTextDecorationComponent: JSInputComponent = {
  Component: TextDecoration,
  handlesCssProperties: ["textDecoration"],
};
